// h5登录页域名
export const LOGIN_HOST = window.location.host === 'm.zuzuche.com' ? 'm.zuzuche.com' : 'm.zuzuche.net';
